<template>
    <div class="ppv2-flex ppv2-justify-center">
        <div class="ppv2-w-full">
            <div class="ppv2-flex ppv2-flex-wrap">
                <!-- Left Column: Permissions -->
                <div class="ppv2-w-1/2 ppv2-p-4">
                    <div class="ppv2-mb-6 ppv2-flex ppv2-flex-col">
                        <h6 class="ppv2-text-left ppv2-text-sm poppinsSemiBold ppv2-text-blue-900 ppv2-mt-2">
                            {{ $t('form_customer_v2.main_information.permissions') }}
                        </h6>

                        <div
                            class="ppv2-flex ppv2-flex-row-reverse ppv2-justify-end ppv2-items-center ppv2-mb-3 ppv2-px-0 ppv2-text-left"
                        >
                            <BaseSwitch
                                v-model="customer.is_booking_online_blocked"
                                :labelLeft="$t('form_customer_v2.main_information.block_online_booking')"
                            />
                        </div>

                        <div
                            class="ppv2-flex ppv2-flex-row-reverse ppv2-justify-end ppv2-items-center ppv2-mb-3 ppv2-px-0 ppv2-text-left"
                        >
                            <BaseSwitch
                                v-model="customer.is_voucher_payment_blocked"
                                :labelLeft="$t('form_customer_v2.main_information.block_payment_by_gift_voucher')"
                            />
                        </div>
                    </div>
                </div>

                <!-- Right Column: GDPR -->
                <div class="ppv2-w-1/2 ppv2-p-4">
                    <div class="ppv2-mb-6 ppv2-flex ppv2-flex-col">
                        <h6 class="ppv2-text-left ppv2-text-sm poppinsSemiBold ppv2-text-blue-900 ppv2-mt-2">
                            {{ $t('form_customer_v2.main_information.GDPR') }}
                        </h6>

                        <div class="form-group form-check form-switch d-flex flex-row-reverse justify-content-end px-0 mb-3">
                            <BaseSwitch
                                v-model="object_rgpd.receive_email"
                                :labelLeft="$t('form_customer_v2.main_information.allow_receiving_emails')"
                            />
                        </div>

                        <div class="form-group form-check form-switch d-flex flex-row-reverse justify-content-end px-0 mb-3">
                            <BaseSwitch
                                v-model="object_rgpd.receive_sms"
                                :labelLeft="$t('form_customer_v2.main_information.allow_receiving_sms_messages')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseSwitch from '../../Shared/BaseSwitch.vue'

export default {
    components: { BaseSwitch },
    props: ['customer', 'user', 'lastRgpd', 'hasEdit'],
    data() {
        const defaultRgpd = {
            receive_email: 0,
            receive_sms: 0,
        }

        return {
            object_rgpd: this.hasEdit && this.lastRgpd ? JSON.parse(JSON.stringify(this.lastRgpd)) : { ...defaultRgpd },
        }
    },
}
</script>
